export default function (controller) {
  $(document).ready(function() {
    setTimeout(function() {
      $('.notice.fadeInDown, .alert.fadeInDown').fadeOut();
    }, 3000);
  })
}
